import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'texto',
  templateUrl: './texto.component.html',
  styleUrls: ['./texto.component.scss'],
})
export class TextoComponent implements OnInit {
  @Input() setPregunta: string
  @Input() tamano: number
  @Input() isEnabled: any
  @Output() valueEmit = new EventEmitter<object>()

  constructor() { }

  ngOnInit() {
    this.isEnabled = false
  }
  reviewChange(event) {
    let texto = event.detail.value || '';
    if (texto.length > 140) {
      texto = texto.substring(0, 140);
      event.target.value = texto;
    }
    const objeto = {texto, pregunta: this.setPregunta}
    this.valueEmit.emit(objeto)
  }
}
